import { margObjectFn } from "./_margObject";
import { mq } from "./_mediaQuery";

/**
 * URLパラメータ(?dest=id名)のidの位置へジャンプする
 * ?gap=数値 でスクロール量を補正する。
 */
export class SmoothScroll {
	/**
	 * 設定を渡して挙動を変えられる
	 * @param {object | null} _config - headerValid / headerSelector / baseGap / behavior
	 */
	constructor(_config = null) {
		this.originalConfig = {
			headerValid: false,
			headerSelector: "header",
			baseGap: 0,
			behavior: "smooth",
		};

		this.config = _config ? margObjectFn({}, this.originalConfig, _config) : this.originalConfig;

		this.body = document.body;

		this.position = 0;

		// jump()を許可するクラス
		this.classNameAllowsJump = "may-jump";
	}

	/**
	 * 遷移量を返す
	 * @param {string} ID - ターゲット要素のID名
	 * @param {number} gap - 遷移量の補正値
	 * @returns {number | null} ターゲット要素が無効であればnullを返す。
	 */
	getPosition(ID = "", gap = 0) {
		const destination = document.getElementById(ID);
		if (!destination) return null;

		let headerHight = 0;
		if (this.config.headerValid) {
			const header = document.querySelector(this.config.headerSelector);
			headerHight = header.offsetHeight;
		}

		const { baseGap } = this.config;
		const rect = destination.getBoundingClientRect().top;
		const offset = window.scrollY;

		const position = rect + baseGap + offset - headerHight + gap;

		return position;
	}

	/**
	 * 遷移する
	 * @param {number | null} position - 遷移量
	 * @returns void
	 */
	jump(position = null) {
		if (typeof position !== "number") return;
		window.scrollTo({
			top: position,
			behavior: this.config.behavior,
		});
	}

	/**
	 * bodyに許可クラスを付与する
	 */
	addClassNameAllowsJump() {
		document.body.classList.add(this.classNameAllowsJump);
	}

	/**
	 * bodyのクラスを監視し、高さが変わったら付与されるクラスがあればjump()を発火させる。
	 */
	watch() {
		const url = new URL(window.location.href);
		const parms = url.searchParams;
		if (!parms.has("jump-dest")) return;

		const targetID = parms.get("jump-dest");

		let gap = 0;
		if (parms.has("jump-gap")) {
			const gapValue = Number(parms.get("jump-gap"));
			gap = Number.isNaN(gapValue) ? 0 : Number(gapValue);
		}

		const watchInterval = setInterval(() => {
			this.position = this.getPosition(targetID, gap);

			const { body } = document;
			if (body && body.classList.contains(this.classNameAllowsJump)) {
				this.jump(this.position);
				clearInterval(watchInterval);
			}
		}, 100);
	}

	/**
	 * href="#〇〇"の〇〇に対応したIDを持つ要素にページ内遷移する。
	 * data-gap="pc時の数値,sp時の数値"で遷移の調整量調整する
	 * @param {function} func - 遷移後に実行する関数
	 * @param {string} triggerClass - トリガー要素のセレクタ
	 */
	setJumpInpage(func = null, triggerClass = "a.js-jump-inpage") {
		const triggers = document.querySelectorAll(triggerClass);
		if (triggers.length === 0) return;

		const clickHandle = (targetID, gap) => {
			const position = this.getPosition(targetID, gap);

			if (typeof position !== "number") return;
			this.jump(position);
			if (typeof func === "function") {
				func.apply(this);
			}
		};

		triggers.forEach((trigger) => {
			const { hash } = trigger;
			const targetID = hash ? hash.replace("#", "") : null;

			let delay = null;
			const delayAttr = trigger.dataset.delay;
			if (trigger.hasAttribute("data-delay") && delayAttr !== "") {
				delay = Number(delayAttr);
			}

			let gap = 0;
			const dataGap = trigger.dataset.gap;
			if (dataGap || dataGap === "") {
				const gapArray = dataGap.split(",").map(Number);
				if (typeof gapArray[1] === "undefined") {
					const value = gapArray[0];
					gapArray[1] = value;
				}
				gap = mq("pc") ? gapArray[0] : gapArray[1];
			}

			trigger.addEventListener("click", (self) => {
				self.preventDefault();
				if (typeof delay === "number") {
					setTimeout(() => {
						clickHandle(targetID, gap);
					}, delay);
				} else {
					clickHandle(targetID, gap);
				}
			});
		});
	}
}

export default SmoothScroll;
